import React from 'react';
import block from 'bem-cn-lite';
import {Button, ButtonProps, Icon} from '@yandex-data-ui/common';
import {ClassNameProps} from '@yandex-data-ui/cloud-components';

import downloadIcon from 'icons/download.svg';

const b = block('DownloadIcon');

export interface DownloadButtonProps
    extends Pick<ButtonProps, 'size' | 'view' | 'onClick'>,
        ClassNameProps {
    iconSize?: number;
    disabled?: boolean;
}

const DownloadButton: React.FC<DownloadButtonProps> = (props) => {
    const {
        size = 'm',
        view = 'normal',
        iconSize = 18,
        disabled = false,
        onClick,
        className,
    } = props;

    return (
        <Button
            size={size}
            view={view}
            className={b(null, className)}
            onClick={onClick}
            disabled={disabled}
        >
            <Icon data={downloadIcon} size={iconSize} />
        </Button>
    );
};

export default DownloadButton;
